import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { useSelector } from 'react-redux';
import Button from '../../elements/Button';
import PasswordField from '../../fields/Password';
import { useNavigate } from 'react-router-dom';
import queryString from 'querystring';
import { IconCheckCircle } from '../../icons/IconCheckCircle';
import styles from './styles.scoped.css';

export default function ResetPassword({
  change = () => {},
  handleSubmit = () => {},
  invalid = true,
  submitSucceeded = false,
}) {
  const navigate = useNavigate();
  const { values } = useSelector((state) => state.form.resetPassword || {});
  const { isLoading, message } = useSelector((s) => s.forgotPassword);
  const [passwordScore, setPasswordScore] = useState(0);

  // Helper to read query string safely without nested ternaries
  const getQueryString = () => {
    const href = typeof window !== 'undefined' && window.location && window.location.href ? window.location.href : '';
    const search = typeof window !== 'undefined' && window.location && window.location.search ? window.location.search : '';
    let source = '';
    if (search && search.length) {
      source = search;
    } else if (href) {
      try {
        source = new URL(href).search || '';
      } catch (e) {
        source = '';
      }
    }
    return source.replace(/^\?/, '');
  };

  // Read token/email from window.location when needed (submit/effect)
  const isMatchPassword = values?.password === values?.repeatPassword;
  const scorePassed = passwordScore > 4;
  const btnDisabled = !scorePassed || !isMatchPassword || invalid || isLoading;

  const passwordProps = {
    placeholder: 'Masukkan kata sandi baru Anda',
    label: 'Kata Sandi Baru',
    icon: 'ic-lock.svg',
  };
  const confirmPasswordProps = {
    placeholder: 'Masukkan ulang kata sandi baru Anda',
    label: 'Ulangi Kata Sandi Baru',
    icon: 'ic-lock.svg',
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const qs = getQueryString();
    const { token: currentToken, email: currentEmail } = queryString.parse(qs);
    await change('token', currentToken);
    await change('email', currentEmail);
    handleSubmit();
  };

  useEffect(() => {
    const qs = getQueryString();
    const { token: currentToken, email: currentEmail } = queryString.parse(qs);
    if (!currentToken || !currentEmail) {
      navigate('/login', { replace: true });
    }
  }, []);

  const goBackHome = () => {
    navigate('/login', { replace: true });
  };

  return (
    <form className={styles.root} onSubmit={onSubmit}>
      <div className={styles['input-container']}>
        <Field
          component={PasswordField}
          inputProps={passwordProps}
          name="password"
          setStrength={setPasswordScore}
          strength={passwordScore}
          withStrength
        />
      </div>
      <div className={styles['input-container']}>
        <Field
          component={PasswordField}
          inputProps={confirmPasswordProps}
          name="repeatPassword"
        />
      </div>
      {scorePassed && isMatchPassword && (
        <span className={styles.valid}>
          <IconCheckCircle /> Kata sandi sama
        </span>
      )}
      {message !== 'SUKSES' && submitSucceeded && (
        <p className={styles.error}>{message}</p>
      )}
      <Button disabled={btnDisabled} style={'blue'} type="submit">
        {isLoading ? 'Mengirim...' : 'Buat Kata Sandi Baru'}
      </Button>
      <Button onClick={goBackHome} style="primary-500" type="button">
        Kembali ke Halaman Login
      </Button>
    </form>
  );
}

ResetPassword.propTypes = {
  change: PropTypes.func,
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  submitSucceeded: PropTypes.bool,
};
